import FrequenciesAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { CustomerDetailDrawerService } from 'app/modules/components/business-partners/customer-detail-drawer';
import { BusinessPartnerNavigationComponent } from 'app/shared/components/business-partner-navigation/business-partner-navigation.component';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { BusinessPartnerBySubRoute } from '../../../../interfaces/busines-partner-by-sub-route.interface';

@Component({
  selector: 'app-client-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    BusinessPartnerNavigationComponent,
    TranslatePipe,
  ],
  templateUrl: './client-cell-renderer.component.html',
  styleUrls: ['./client-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientCellRendererComponent {
  private readonly customerDrawer = inject(CustomerDetailDrawerService);

  readonly params = input.required<CellRendererParams<BusinessPartnerBySubRoute>>();

  readonly data = computed(() => this.params()?.data);

  readonly code = computed(() => this.data()?.externalKeys?.code ?? '-');

  readonly name = computed(() => this.data()?.name ?? '-');

  readonly commercialName = computed(() => this.data()?.commercialName ?? '');

  readonly subRoutes = computed<FrequenciesAttributes[]>(() => this.data()?.subRoutes ?? []);

  readonly subRoutesCount = computed(() => this.subRoutes().length);

  readonly businessPartnerForNavigation = computed(() => ({
    id: this.data()?._id,
    code: this.code(),
    name: this.name(),
    externalKeys: this.data()?.externalKeys,
  }));

  // Callback from params to open modal
  readonly onOpenSubRoutes = computed(
    () => this.params()?.onOpenSubRoutes as ((bp: BusinessPartnerBySubRoute) => void) | undefined
  );

  /**
   * Mongo `_id` of the sub-route's company, supplied by the grid via
   * `cellRendererParams`. A sub-route belongs to exactly one company, so the
   * drawer must resolve the partner's per-company values (`bpCompanies[]`) with
   * it instead of the deprecated root copies.
   */
  readonly companyId = computed(() => {
    const getCompanyId = this.params()?.getCompanyId as (() => string | null | undefined) | undefined;
    return getCompanyId?.() ?? undefined;
  });

  onBadgeClick(): void {
    const data = this.data();
    const callback = this.onOpenSubRoutes();
    if (data && callback) {
      callback(data);
    }
  }

  openCustomerDetail(): void {
    const id = this.data()?._id;
    if (id) {
      this.customerDrawer.open(id, this.companyId());
    }
  }
}
